export function OutlineRouteSlashIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1769 11.1756C12.0546 12.7536 11.9753 14.8499 10.6213 16.2973L9.51481 17.4038L7.38116 19.5421L5.25685 17.4038L4.05697 16.2039C1.72723 13.5847 3.43135 8.97656 7.38116 8.97656C8.18887 8.97656 8.89853 9.16798 9.50081 9.49947"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M17.8391 3.00467C15.43 3.00467 14.3889 5.8153 15.8082 7.4167L16.5412 8.1497L17.8391 9.4523L19.1417 8.1497L19.8187 7.47273C21.3081 5.88066 20.2763 3 17.8391 3V3.00467Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M11.7559 20.513H18.5677C19.1046 20.513 19.5901 20.2935 19.9403 19.9434"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6738 14.6719V14.6812C14.6738 15.7504 15.5422 16.6234 16.6161 16.6234H16.6254"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 20.9975L19.9401 19.9424V19.9377L16.6253 16.6228L14.6737 14.6713L11.1768 11.1743L9.50067 9.49823L3.00635 3.00391"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
